import { RatingTypeEnum } from "../enums/ratingTypeEnum.enum";
import { PpeType } from "../enums/ppeType.enum";

export class Ppe {
    id: string;
    name: string;
    type: PpeType;
    organizationLevelId: string;
    fileName: string;
    iconUrl: string;
    brand: string;
    model: string;
    rating: number;
    ratingType: RatingTypeEnum;
    description: string;
}

